<template>
  <div class="hello">
    <div class="bod">
      <div class="foote" ref="foote">
        <div class="tab">
          <span>收银台</span>
        </div>
        <div class="comfile">
          <div class="left_pay">
            <div class="icon">
              <img src="../assets/image/success.png" alt="">
            </div>
          </div>
          <div class="right_pay">
            <div class="top_pay">
              <div class="top_title">
                <span>订单提交成功，请尽快完成付款！订单金额： ¥{{detail.all_price}}</span>
              </div>
              <div class="mines">
                <span>请您在提交订单后 <span style="color: #2B7FD7;">10分钟</span> 内完成支付</span>
              </div>
            </div>
            <div class="bottom_pay">
              <div class="detail">
                <span>订单详情</span>
              </div>
              <div class="number">
                <span>订单号：{{detail.ordersn}}</span>
              </div>
              <div class="number">
                <span style="float: left;">商品名称:</span>
                <div style="float: left;margin-left: 15px;">

                  <p v-for="(item,index) in detail.orderGoods" :key="index">
                    {{item.goods_title}} {{item.spec_name}}
                  </p>
                </div>
              </div>
              <div class="clear"></div>
              <div class="number">
                <span>订单总额：￥{{detail.all_price}}</span>
              </div>
              <div class="number">
                <span>下单时间：{{detail.create_time}}</span>
              </div>
              <div class="number">
                <span>收货信息：{{detail.orderAddress.province}} {{detail.orderAddress.city}} {{detail.orderAddress.area}}
                  {{detail.orderAddress.detail}}</span>
              </div>
            </div>
          </div>


        </div>

        <div class="payment">
          <div class="top_titl">
            <span>平台支付</span>
          </div>
          <div class="pay_ment">
            <div class="paymentList">
              <div class="zhifu">
                <img src="../assets/image/zhifubao.png" alt="">
              </div>
              <a :href="url">
                <div class="zhifu_title" @click="zhifubao()">
                  <span>支付宝支付</span>
                </div>
              </a>
            </div>
            <!--  <div class="paymentList" @click="weixin()">
              <div class="zhifu">
                <img src="../assets/image/weixin_pay.png" alt="">
              </div>
              <div class="zhifu_title">
                <span>微信支付</span>
              </div>
            </div> -->
          </div>
        </div>
        <div class="weixin" v-if="imgShpw">
          <div class="close" @click="closeEvent">
            <img src="../assets/image/close.png" alt="">
          </div>
          <div class="weixin_top">
            <span>微信支付</span>
          </div>
          <div class="weixin_pay">
            <div id="qrcode" ref="qrcode"></div>
          </div>
          <div class="weixin_title">
            <span>请使用微信扫一扫</span>
          </div>
          <div class="weixin_success">
            <span>二维码完成支付</span>
          </div>
        </div>
        <div style="height: 300px;"></div>
      </div>
      <fiex :shows="fixed" :fatherMethod="goTop" ref="fiex"></fiex>
    </div>
  </div>
</template>

<script>
  import QRCode from 'qrcodejs2'
  import {
    Loading
  } from 'element-ui';
  import fiex from '../components/fiex.vue'
  var loading;
  export default {
    data() {
      return {
        fixed: true,
        imgShpw: false,
        src: '',
        detail: {},
		url:'',
		flags:false,
        trime: null,
        flag: true
      }
    },
    components: {
      QRCode,
      fiex
    },
    created() {
		var that = this;
		console.log(this.$route.query.order_id,'1232312312312312')
		if(!this.flags){
			this.url = 'http://shoot.pingyao888.cn/index.php/api/order/alipcpay?order_id=' +this.$route.query.order_id
		}else{
			this.url = 'https://admin.pipyz.com.cn/index.php/api/order/alipcpay?order_id' + this.$route.query.order_id
		}
      // 获取订单信息
      // this.detail = JSON.parse(localStorage.getItem('detail'));
      // this.$set(this.detail,{},JSON.parse(localStorage.getItem('detail')))

      // this.detail = {};
      //  this.detail = JSON.parse(localStorage.getItem('detail'));
      // this.detail = Object.assign({},this.detail);
      
        this.$fetch('order/detail', {
          id: this.$route.query.order_id
        }).then(res => {
          this.detail = res.data;
        })
    },
    destroyed() {
      // this.detail = {};
      // localStorage.removeItem('detail');
    },
    methods: {
      creatQrCode(url) {
        var qrcode = new QRCode('qrcode', {
          width: 266,
          height: 246,
          text: url, // 二维码地址
          colorDark: "#000",
          colorLight: "#fff",
          correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
        })
      },
      weixin() {
        var that = this;
        var data = {
          order_id: parseInt(this.detail.order_id)
        }
        this.$fetch('order/wxNativePay', data).then(res => {
          if (res.code == 200) {
            that.$nextTick(function() {
              that.$nextTick(function() {
                that.creatQrCode(res.data);
              });
            })
            this.imgShpw = true;
          }
        })

        var trime = setInterval(() => {
          this.$fetch('order/payStatus', {
            order_id: parseInt(this.detail.order_id)
          }).then(res => {
            if (res.code == 200) {
              this.imgShpw = false;
              clearInterval(trime)
              this.$router.push({
                path: '/personal'
              })
            }
          })
        }, 1000)
        if (this.flag) {
          clearInterval(trime)
        }

      },
      goTop() {
        this.$refs.foote.scrollTop = 0
      },
      zhifubao() {
        // this.$fetch('order/aliPcPay',{order_id:this.detail.order_id}).then(res=>{
        //    console.log(res);
        // })
      },
      closeEvent() {
        this.flag = true;
        this.imgShpw = false;
      }
    }
  }
</script>

<style scoped="scoped">
  @import url("../assets/css/Cashier.css");
</style>



// WEBPACK FOOTER //
// src/pages/Cashier.vue